import PromoTile from './PromoTile';

export default PromoTile;
